import { render, staticRenderFns } from "./EditarLeilao.vue?vue&type=template&id=355146be&"
import script from "./EditarLeilao.vue?vue&type=script&lang=js&"
export * from "./EditarLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports